import { readDomainCookie, writeDomainCookie } from '@/lib/domain_cookie';

export const CONTACT_GATE_SOURCES = ['applications', 'recruit-sitter', 'profile'] as const;

export function getRouteSource(routeQuery: Record<string, any>): string | undefined {
  return routeQuery.source as string | undefined;
}

export function isContactGatePricingSource(routeQuery: Record<string, any>): boolean {
  const source = getRouteSource(routeQuery);
  return Boolean(source && (CONTACT_GATE_SOURCES as readonly string[]).includes(source));
}

export function getCouponCode(routeQuery: Record<string, any>): string | undefined {
  const routePromo = routeQuery.promo as string | undefined;
  const cookiePromo = readDomainCookie('promo');

  return routePromo || cookiePromo || undefined;
}

export function persistCouponCode(promoCode: string): void {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 1);
  writeDomainCookie('promo', promoCode, { expires: expiryDate });
}
